export default __webpack_public_path__ + "static/media/18-stakeholder-map-2.1611b4f1.svg";